module.exports = __webpack_public_path__ + "static/media/photo-320.7db6a7e0.png";